import { cardContainerStyles } from "@insite/content-library/Components/CardContainer";
import {recentOrdersStyles} from "@insite/content-library/Widgets/Common/RecentOrders";
import {recentQuotesStyles} from "@insite/content-library/Widgets/Common/RecentQuotes";
import { css } from "styled-components";

recentOrdersStyles.noOrdersFoundText = {
    css: css`
    padding-left: 15px;
    `
}

recentQuotesStyles.noQuotesText = {
    css: css`
    padding-left: 15px;
    `
}

cardContainerStyles.cardDivider = {
    css: css`
        width: 100%;
        margin: 0;
        border-bottom: none;
    `,
};
cardContainerStyles.gridItem = {
    width: 12,
    css: css`
        padding-bottom: 0px;
    `,
};
